import {Slider as MuiSlider} from '@mui/material';

export default MuiSlider;
